// 活动列表组件- 接收活动类型，和对应类型列表数据
<template>
    <div class="list-box">
        <div class="left-label-icon">
            <BuyCarItemTag  :text="activeTypeName" style="background:linear-gradient(328deg, #FF6831 0%, #F3180E 100%)" />
        </div>
        <!-- list -->
        <div
            class="coupon-list"
            :class="{ 'item-has-margin':activeList.length > 1 }"
        >
            <div class="item" v-for="(item, index) in activeList" :key="index">
                {{ item.Name }}
            </div>
        </div>
    </div>
</template>
<script>
import BuyCarItemTag from './BuyCarItemTag.vue'
export default {
    name: '',
    mixins: [],
    components: {BuyCarItemTag},
    // 数据部分
    props: {
        activeTypeName: {
            type: String,
            default: '多买优惠',
        },
        activeList:{
          type: Array,
          default:()=>[]
        }
    },
    data() {
        return {
            // activeList: [
            //     { name: '新用户首单返100商品劵' },
            //     { name: '订单满1000，总价打9.5折，并赠送头孢克肟胶囊 x 30' },
            // ],
        }
    },
    computed: {},
    watch: {},
    // 生命周期
    created() {},
    mounted() {},
    unmounted() {},
    // 方法
    methods: {
        toCouponCenter() {
            console.log()
        },
    },
}
</script>
<style lang="less" scoped>
.list-box {
    margin-top: 13px;
    box-sizing: border-box;
    display: flex;
    text-align: left;
    align-items: flex-start;
    padding-bottom: 16px;
    &:last-child{
      padding-bottom: 0;
    }
    .coupon-list {
        flex: 1;
        &.item-has-margin {
            .item {
                margin-bottom:8px;
            }
        }
        .item {
          font-size: 14px;
          color: #111A34;
          line-height: 1;
        }
    }
}
</style>
